import { DevChatFrontendToolBase } from './DevChatFrontendToolBase';
import { GetTimeFrontendTool } from './GetTimeFrontendTool';
import { WriteFileMockFrontendTool } from './WriteFileMockFrontendTool';
import { EvalApprovedFunctionFrontendTool } from './EvalApprovedFunctionFrontendTool';

const DEV_CHAT_FRONTEND_TOOL_CLASSES = [
  GetTimeFrontendTool,
  WriteFileMockFrontendTool,
  EvalApprovedFunctionFrontendTool,
];

export function getDevChatFrontendToolDefinitionList() {
  return DEV_CHAT_FRONTEND_TOOL_CLASSES.map((C) => C.toSerializableDefinition());
}

export function getDevChatFrontendToolById(toolId) {
  return DEV_CHAT_FRONTEND_TOOL_CLASSES.find((C) => C.toolId === toolId) || null;
}

export async function executeDevChatFrontendTool(toolId, params, context) {
  const ToolClass = getDevChatFrontendToolById(toolId);
  if (!ToolClass) {
    throw new Error(`Unknown Dev Chat frontend tool: ${toolId}`);
  }
  const instance = new ToolClass();
  return instance.execute(params && typeof params === 'object' ? params : {}, context);
}

export function formatDevChatFrontendToolBubbleSummary(toolId, result) {
  const ToolClass = getDevChatFrontendToolById(toolId);
  if (ToolClass && typeof ToolClass.formatBubbleSummary === 'function') {
    return ToolClass.formatBubbleSummary(result);
  }
  return DevChatFrontendToolBase.formatBubbleSummary(result);
}
